import Cookies from 'js-cookie';
import { APP_TYPE } from '@/config/env'

const TokenKey = `${APP_TYPE}_x-access-token`

// let inFifteenMinutes = new Date(new Date().getTime() + 120 * 60 * 1000)

export function getToken () {
    return Cookies.get(TokenKey)
}

export function setToken (token) {
    return Cookies.set(TokenKey, token)
    // return Cookies.set(TokenKey, token, { expires: inFifteenMinutes })
}

export function removeToken () {
    return Cookies.remove(TokenKey)
}